<template>
  <span class="ms-3">{{ cardName }}</span>
</template>

<script lang="ts">
import { Options, Vue, prop } from "vue-class-component";

class Props {
  text = prop<string>({ required: true, default: "" });
}

@Options({
  components: {},
})
class ComponentName extends Vue.with(Props) {
  get cardName(): string {
    const texts = this.text.split(".");
    texts.pop();
    return texts ? texts.join(".") : "";
  }
}
export default ComponentName;
</script>

<style lang="scss" scoped></style>
